import { render, staticRenderFns } from "./feishuBitable.vue?vue&type=template&id=60805294&scoped=true"
import script from "./feishuBitable.vue?vue&type=script&lang=js"
export * from "./feishuBitable.vue?vue&type=script&lang=js"
import style0 from "./feishuBitable.vue?vue&type=style&index=0&id=60805294&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60805294",
  null
  
)

export default component.exports